import React from "react";
import { GAevent } from "../../../../utils/googleAnalyticsHelper";
import styles from "./ProductDetailsButton.module.scss";

const ProductDetailsButton = ({ product }) => {
  const { Model, Link } = product;

  const handleClick = () => {
    GAevent("Guest-User", "click", `See More Details Button - ${Model}`);
  };

  return (
    <>
      {Link && (
        <button className={styles.btn}>
          <a className={`productDetailsButton - ${Model}`} href={Link} rel="noreferrer" target="_blank" onClick={handleClick}>
            See More Details
          </a>
        </button>
      )}
    </>
  );
};

export { ProductDetailsButton };
